"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (serialized, global) {
    if (global === void 0) { global = window; }
    var m = new Map();
    function getHydratedValue(id) {
        var e_1, _a, e_2, _b, e_3, _c, e_4, _d, e_5, _e, e_6, _f;
        if (m.has(id)) {
            return m.get(id);
        }
        var o = serialized[id];
        var hydratedVal;
        switch (o.type) {
            case 'boolean':
                hydratedVal = o.value;
                break;
            case 'string':
                hydratedVal = o.value;
                break;
            case 'symbol':
                hydratedVal = Symbol(o.value);
                break;
            case 'number':
                hydratedVal = o.value;
                break;
            case 'bigint':
                hydratedVal = BigInt(o.value);
                break;
            case 'infinity':
                hydratedVal = o.value === '+' ? Infinity : -Infinity;
                break;
            case 'neg0':
                hydratedVal = -0;
                break;
            case 'nan':
                hydratedVal = NaN;
                break;
            case 'undefined':
                hydratedVal = undefined;
                break;
            case 'null':
                hydratedVal = null;
                break;
            case 'date':
                hydratedVal = new Date();
                hydratedVal.setTime(o.value);
                break;
            case 'error': {
                var Ctor = Error;
                var hasCtor = o.value.name in global;
                if (hasCtor) {
                    Ctor = global[o.value.name];
                }
                var err = new Ctor(o.value.message);
                err.stack = o.value.stack;
                if (!hasCtor) {
                    err.name = o.value.name;
                }
                hydratedVal = err;
                break;
            }
            case 'regexp':
                hydratedVal = new RegExp(o.value.src, o.value.flags);
                break;
            case 'typedarray':
                hydratedVal =
                    typeof global[o.value.ctor] === 'function'
                        ? new global[o.value.ctor](o.value.viewArr)
                        : o.value.viewArr;
                break;
            case 'arraybuffer': {
                hydratedVal = new ArrayBuffer(o.value.length);
                var view = new Int8Array(hydratedVal);
                view.set(o.value);
                break;
            }
            case 'function': {
                var tempFunc = function () { };
                if (typeof o.value.name === 'string') {
                    Object.defineProperty(tempFunc, 'name', {
                        value: o.value.name,
                        writable: false,
                    });
                }
                if (typeof o.value.body === 'string') {
                    Object.defineProperty(tempFunc, 'body', {
                        value: o.value.body,
                        writable: false,
                    });
                    Object.defineProperty(tempFunc, 'toString', {
                        value: function () { return o.value.body; },
                        writable: false,
                    });
                }
                if (typeof o.value.proto === 'string') {
                    tempFunc.constructor = {
                        name: o.value.proto,
                    };
                }
                return tempFunc;
            }
            case 'array':
                hydratedVal = [];
                m.set(id, hydratedVal);
                try {
                    for (var _g = __values(o.value), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var childId = _h.value;
                        hydratedVal.push(getHydratedValue(childId));
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                break;
            case 'object':
                hydratedVal = {};
                m.set(id, hydratedVal);
                try {
                    for (var _j = __values(o.value), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var _l = _k.value, key = _l.key, value = _l.value;
                        hydratedVal[getHydratedValue(key)] = getHydratedValue(value);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
                break;
            case 'map':
                hydratedVal = new Map();
                m.set(id, hydratedVal);
                try {
                    for (var _m = __values(o.value), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var _p = _o.value, key = _p.key, value = _p.value;
                        hydratedVal.set(getHydratedValue(key), getHydratedValue(value));
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
                break;
            case 'set':
                hydratedVal = new Set();
                m.set(id, hydratedVal);
                try {
                    for (var _q = __values(o.value), _r = _q.next(); !_r.done; _r = _q.next()) {
                        var value = _r.value.value;
                        hydratedVal.add(getHydratedValue(value));
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_r && !_r.done && (_d = _q.return)) _d.call(_q);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
                break;
            case 'domnode': {
                var parser = new window.DOMParser();
                var document_1 = parser.parseFromString(o.value, 'application/xml');
                hydratedVal = document_1.firstChild;
                if (!hydratedVal) {
                    break;
                }
                if (hydratedVal instanceof window.Element) {
                    hydratedVal.removeAttribute('xmlns');
                }
                break;
            }
            case 'htmlcollection': {
                var root = window.document.createDocumentFragment();
                try {
                    for (var _s = __values(o.value), _t = _s.next(); !_t.done; _t = _s.next()) {
                        var elId = _t.value;
                        var el = getHydratedValue(elId);
                        if (el instanceof window.Element) {
                            root.appendChild(el);
                        }
                    }
                }
                catch (e_5_1) { e_5 = { error: e_5_1 }; }
                finally {
                    try {
                        if (_t && !_t.done && (_e = _s.return)) _e.call(_s);
                    }
                    finally { if (e_5) throw e_5.error; }
                }
                hydratedVal = root.children;
                break;
            }
            case 'nodelist': {
                var root = window.document.createDocumentFragment();
                try {
                    for (var _u = __values(o.value), _v = _u.next(); !_v.done; _v = _u.next()) {
                        var elId = _v.value;
                        var el = getHydratedValue(elId);
                        if (el instanceof window.Element) {
                            root.appendChild(el);
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_v && !_v.done && (_f = _u.return)) _f.call(_u);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
                hydratedVal = root.childNodes;
                break;
            }
            default:
                assertNever(o);
        }
        m.set(id, hydratedVal);
        return hydratedVal;
    }
    return getHydratedValue(0);
});
function assertNever(_x) {
    throw new Error("Didn't expect to get here");
}
//# sourceMappingURL=revive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@replit/alcor/dist/revive.js
// module id = 30
// module chunks = 0